import { Routes, Route } from "react-router-dom";
import Dashboard from "./components/Dashboard";
import Navbar from "./components/Navbar";
import Login from "./components/Login";
import Sidebar from "./components/Sidebar";
import IntelliBill from "./pages/IntelliBill";
import ClaimApproval from "./pages/ClaimApproval";
import LabBilling from "./pages/LabBilling";
import ClaimStatus from "./pages/ClaimStatus";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import TransactionLogs from "./pages/TransactionLogs";
import PostingPayments from "./pages/PostingPayments";

import TabNavigation from "./components/TabNavigation";

import LoginLocation from "./components/LoginLocation";
import PatDasboardNavigation from "./components/PatDashboardNavigation";

import Remittance from "./pages/Remittance";
import NewEncounterPage from "./pages/Encounter";
import ClaimMacro from "./pages/ClaimMacro";
import SuperBill from "./pages/SuperBill";
import GeneralDocuments from "./pages/GeneralDocuments";
import PatientInsTab from "./components/PatientInsTab";
import PatientTrackerTabs from "./components/PatientTrackerTabs";
import InsPaymentReport from "./pages/InsPaymentReport";
import EditCpt from "./pages/EditCpt";
import AgingReport from "./pages/AgingReport";
import ARClaimDetails from "./pages/ARClaimDetails";
import ProtectedRoute from "./components/ProtectedRoute";
import PatientContacts from "./components/PatientContacts";
import { useSelector } from "react-redux";
import useAuthAndInactivity from "./common/hook/useAuthAndInactivity";
const App = () => {
  const userData = useSelector((state) => state.user.user);
  const userPracticeID = userData ? userData.practiceID : null;
  const userId = userData ? userData.userID : null;
  const { logout } = useAuthAndInactivity(userData, userPracticeID, userId);
  return (
    <>
      {userData && <Sidebar />}

      {userData && <Navbar handleLogout={logout} />}
      <ToastContainer />

      <Routes>
        <Route path="/" element={<Login />} />
        <Route
          path="/locations"
          element={<ProtectedRoute element={<LoginLocation />} />}
        />
        <Route
          path="/Billingdasboard"
          element={<ProtectedRoute element={<Dashboard />} />}
        />
        <Route
          path="/Intellibill"
          element={<ProtectedRoute element={<IntelliBill />} />}
        />
        <Route
          path="/Claimapproval"
          element={<ProtectedRoute element={<ClaimApproval />} />}
        />
          <Route
          path="/PatientContacts/:id/*"
          element={<ProtectedRoute element={<PatientContacts />} />}
        />
        <Route
          path="/LabBilling"
          element={<ProtectedRoute element={<LabBilling />} />}
        />
        <Route
          path="/MedicalClaimStatus"
          element={<ProtectedRoute element={<ClaimStatus />} />}
        />
        <Route
          path="/MedicalClaimStatus/:InsID"
          element={<ProtectedRoute element={<ClaimStatus />} />}
        />
        <Route
          path="/new-encounter"
          element={<ProtectedRoute element={<NewEncounterPage />} />}
        />
        <Route
          path="/Upload-RemittanceFiles"
          element={<ProtectedRoute element={<Remittance />} />}
        />
        <Route
          path="/PostingPayments"
          element={<ProtectedRoute element={<PostingPayments />} />}
        />
        <Route
          path="/MedicalClaimMacro"
          element={<ProtectedRoute element={<ClaimMacro />} />}
        />
        <Route
          path="/SuperBill"
          element={<ProtectedRoute element={<SuperBill />} />}
        />
        <Route
          path="/GeneralDocuments/:id"
          element={<ProtectedRoute element={<GeneralDocuments />} />}
        />
        <Route
          path="/BillerPatientTracker/*"
          element={<ProtectedRoute element={<PatientTrackerTabs />} />}
        />
        <Route
          path="/new-encounter/:id"
          element={<ProtectedRoute element={<NewEncounterPage />} />}
        />
        <Route
          path="/InsurancePaymentReport"
          element={<ProtectedRoute element={<InsPaymentReport />} />}
        />
        <Route
          path="/RHMAgingRecievedCharges"
          element={<ProtectedRoute element={<AgingReport />} />}
        />
        <Route
          path="/ARAgingReportClaimDetails"
          element={<ProtectedRoute element={<ARClaimDetails />} />}
        />
        <Route
          path="/UpdateCPT"
          element={<ProtectedRoute element={<EditCpt />} />}
        />
        <Route
          path="/transactionlogs/:id"
          element={<ProtectedRoute element={<TransactionLogs />} />}
        />

        <Route
          path="/patient-dashboard/:id/*"
          element={<ProtectedRoute element={<PatDasboardNavigation />} />}
        />
        <Route
          path="/patient-insurance/:id/*"
          element={<ProtectedRoute element={<PatientInsTab />} />}
        />

        <Route
          path="/workableclaims/*"
          element={<ProtectedRoute element={<TabNavigation />} />}
        />

        
        <Route
          path="/PatientContacts/:id/*"
          element={<ProtectedRoute element={<PatientContacts />} />}
        />
      </Routes>
    </>
  );
};

export default App;
